const promise = require('es6-promise');

require('isomorphic-fetch');

promise.polyfill();
module.exports.Client = require('./client'); // TODO: Remove "RealClient" export...

module.exports.RealClient = require('./client');
module.exports.AuthProvider = require('./auth/auth-provider');
module.exports.TokenProvider = require('./auth/token-provider');
module.exports.entities = require('./entities');
module.exports.pipelines = require('./pipelines');
module.exports.stores = require('./stores');
module.exports.events = require('./events');